import { useMemo } from 'react';

export const useFilteredPaginatedData = <T>(
  filteredData: T[],
  page: number,
  pageSize: number,
) => {
  return useMemo(() => {
    const start = (page - 1) * pageSize;
    return {
      paginated: filteredData.slice(start, start + pageSize),
      filteredCount: filteredData.length,
    };
  }, [filteredData, page, pageSize]);
};
